// extracted by mini-css-extract-plugin
module.exports = {"header":"AffiliateStaffEditPage_header__2b_-a"};